<div class="modal-header">
  <h4 class="modal-title"> {{'favoriteArticlesOrderPopup.title' | translate}} </h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <div>
      <tabset #tabset>
        <tab class="p-0" *ngFor="let navigatorContent of navigatorContents;" (select)="changeTab(navigatorContent)">
          <ng-template tabHeading>
            <strong>{{navigatorContent.tabHeaderText | translate}}</strong>
          </ng-template>
          <table class="table table-striped table-hover" fixedHeader>
            <thead>
              <tr>
                <th width="7%">{{'favoriteArticlesOrderPopup.grid_column.header.order_index' | translate}}</th>
                <th width="20%">{{'favoriteArticlesOrderPopup.grid_column.header.article_no' | translate}}</th>
                <th width="20%">{{'favoriteArticlesOrderPopup.grid_column.header.own_article_number' | translate}}</th>
                <th width="43%">{{'favoriteArticlesOrderPopup.grid_column.header.description' | translate}}</th>
                <th></th>
                <th *ngIf="navigatorContent.isArticlesDeletable"></th>
              </tr>
            </thead>
          </table>
          <div class="overflow-xh" maxHeightOffset="350" style="min-height: 150px" #scrollContainer>
            <table class="table table-striped table-hover fixed-layout">
              <tbody minRowCount [update]="update">
              <ng-template ngFor let-favoriteArticle [ngForOf]="navigatorContent.favoriteArticles" let-i="index">
                <tr [class.active]="i === navigatorContent.selectedIndex"
                    #row
                    (click)="selectFavoriteArticle(navigatorContent, i, favoriteArticle); setScrollInfo(scrollContainer, row)">
                  <td width="7%">{{navigatorContent.indexColumnLabelFunction(favoriteArticle)}}</td>
                  <td width="20%">{{favoriteArticle.articleNumber}}</td>
                  <td width="20%">{{navigatorContent.getCustomNumberArticleByArticleNumber(favoriteArticle)}}</td>
                  <td [width]="navigatorContent.isArticlesDeletable ? '43%' : '48%'" class="text-overflow"
                      tooltip [tooltipText]="favoriteArticle.displayName">
                    {{favoriteArticle.displayName}}
                  </td>
                  <td>
                    <a href="javascript:void(0)" (click)="navigatorContent.showArticleTechnicalInfo(favoriteArticle)"
                       tooltip [tooltipText]="'article.list.details' | translate" tooltipPosition="bottom">
                      <app-svg-icon type="external-link" size="medium-small"/>
                    </a>
                  </td>
                  <td *ngIf="navigatorContent.isArticlesDeletable">
                    <a href="javascript:void(0)" (click)="removeArticle(navigatorContent, favoriteArticle)"
                       tooltip [tooltipText]="'favoriteArticlesOrderPopup.button_label.remove_article' | translate" tooltipPosition="bottom">
                      <app-svg-icon type="delete" size="medium-small"/>
                    </a>
                  </td>
                </tr>
              </ng-template>
              </tbody>
            </table>
          </div>
        </tab>
      </tabset>
    </div>
  </div>
</div>
<div class="modal-body flex-shrink-0" *ngIf="isArticlesSortable">
  <div class="row">
    <div class="col-sm-6 pe-1">
      <button type="button" class="btn btn-secondary w-100" [disabled]="selectedIndex === -1 || !isMoveUpOperationAvailable" (click)="moveUp()">
        {{'favoriteArticlesOrderPopup.button_label.up' | translate}}
      </button>
    </div>
    <div class="col-sm-6 ps-1">
      <button type="submit" class="btn btn-secondary w-100" [disabled]="selectedIndex === -1 || !isMoveDownOperationAvailable" (click)="moveDown()">
        {{'favoriteArticlesOrderPopup.button_label.down' | translate}}
      </button>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary btn-cancel" (click)="close()">
    {{ editFavoriteArticlesPermission ? ('global.label.cancel' | translate) : ('global.label.close' | translate) }}
  </button>
  <button type="submit" class="btn btn-primary btn-forward" *ngIf="editFavoriteArticlesPermission" (click)="saveFavoriteArticles()">
    {{'global.label.save' | translate}}
  </button>
</div>
